import * as helper from '../../../Assets/Js/helper';
import * as Events from './../../Assets/Js/Events';
import {chatFrameHandler} from '../../../Assets/Js/ChatFrameHandler';

require('../CSS/styles.scss');

import {library, dom} from '@fortawesome/fontawesome-svg-core';
import {faVolumeUp, faUndo, faComments} from '@fortawesome/pro-solid-svg-icons';

library.add(faComments, faUndo, faVolumeUp);
dom.watch();

helper.onDocumentLoaded(() => {
	let paytourObjects = helper.$('.paytour');
	for (let index in paytourObjects) {
		if (paytourObjects.hasOwnProperty(index)) {
			let item = paytourObjects[index];
			helper.addEventListener(item, 'click', () => {
				helper.triggerEvent(window, Events.CREATE_SIGNUP);
			});
		}
	}

	const ab6 = parseInt(helper.getData(helper.$('#information'), 'ab6'));

	chatFrameHandler(ab6);
});
